import { QueryParamsModel } from '../../../_base/crud/models/query-models/query-params.model';
import { forkJoin } from 'rxjs';
// Angular
import { Injectable } from '@angular/core';
// RxJS
import { mergeMap, map, tap, delay } from 'rxjs/operators';
// NGRX
import { Effect, Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
// CRUD
import { QueryResultsModel } from '../../../_base/crud';
// Services
import { WarehouseService } from '../_services/warehouse.service';
import { ShareddataserviceService } from '../../../../shared/shareddataservice.service';
// State
import { AppState } from '../../../../core/reducers';
// Actions
import {
    WarehouseActionTypes,
    WarehousePageRequested,
    WarehousePageLoaded,
    OneWarehouseDeleted,
    WarehouseActionToggleLoading,
    WarehousePageToggleLoading,
    WarehouseUpdated,
    WarehouseCreated,
    WarehouseOnServerCreated
} from '../_actions/warehouse.actions';
import { of } from 'rxjs';

@Injectable()
export class WarehouseEffects {
    showPageLoadingDistpatcher = new WarehousePageToggleLoading({ isLoading: true });
    showActionLoadingDistpatcher = new WarehouseActionToggleLoading({ isLoading: true });
    hideActionLoadingDistpatcher = new WarehouseActionToggleLoading({ isLoading: false });

    @Effect()
    loadWarehousePage$ = this.actions$.pipe(
        ofType<WarehousePageRequested>(WarehouseActionTypes.WarehousePageRequested),
        mergeMap(({ payload }) => {
            this.store.dispatch(this.showPageLoadingDistpatcher);
            const requestToServer = this.warehouseService.findWarehouses(payload.page);
            const lastQuery = of(payload.page);
            return forkJoin(requestToServer, lastQuery);
        }),
        map(response => {
            const result: QueryResultsModel = response[0];
            const lastQuery: QueryParamsModel = response[1];

            this.sharedService.updateWarehouseList(result.items);
            //console.log(result.items);
            const pageLoadedDispatch = new WarehousePageLoaded({
                warehouses: result.items,
                totalCount: result.totalCount,
                page: lastQuery
            });
            return pageLoadedDispatch;
        })
    );

    @Effect()
    deleteWarehouse$ = this.actions$
        .pipe(
            ofType<OneWarehouseDeleted>(WarehouseActionTypes.OneWarehouseDeleted),
            mergeMap(({ payload }) => {
                this.store.dispatch(this.showActionLoadingDistpatcher);
                return this.warehouseService.deleteWarehouse(payload.WarehouseId);
            }
            ),
            map(() => {
                return this.hideActionLoadingDistpatcher;
            }),
        );

    @Effect()
    updateWarehouse$ = this.actions$
        .pipe(
            ofType<WarehouseUpdated>(WarehouseActionTypes.WarehouseUpdated),
            mergeMap(({ payload }) => {
                this.store.dispatch(this.showActionLoadingDistpatcher);
                return this.warehouseService.updateWarehouse(payload.warehouse.WarehouseId, payload.warehouse);
            }),
            map(() => {
                return this.hideActionLoadingDistpatcher;
            })
        );

    @Effect()
    createWarehouse$ = this.actions$
        .pipe(
            ofType<WarehouseOnServerCreated>(WarehouseActionTypes.WarehouseOnServerCreated),
            mergeMap(({ payload }) => {
                this.store.dispatch(this.showActionLoadingDistpatcher);
                return this.warehouseService.createWarehouse(payload.warehouse).pipe(
                    tap(res => {
                        //console.log(res);
                        //const resValue = Object.keys(res).map(key => res[key]);
                        //console.log(resValue[0].value);
                        //this.store.dispatch(new WarehouseCreated({ warehouse: res }));
                        if (res.WarehouseId == 0) {
                            this.store.dispatch(new WarehouseCreated({ warehouse: res }));
                        } else {
                            console.log('There is somthing wrong');
                            //this.store.dispatch(new WarehouseErrorMessage({ _errorMessage: resValue[0].value }));
                        }

                    })
                );
            }),
            map(() => {
                return this.hideActionLoadingDistpatcher;
            }),
        );

    constructor(private actions$: Actions, private warehouseService: WarehouseService, 
        private sharedService: ShareddataserviceService,
        private store: Store<AppState>) { }
}
